export const ru = {
    moscow: 'Москва',
    'phone-extension': 'доб. {phone}',
    regions: 'Регионы'
};
